import $ from 'jquery';

export function ajaxifyBasket() {
    var $headerRoot = $('#headerBasket');
    $('#headerBasket form, #headerBasket a.js-ajaxifiable').ajaxify({
        refresh: [
            '#headerBasket'
        ],
        history: false,
        onStart: function() {
            $headerRoot.addClass('b-basket--loading-in-progress');
        },
        onFinish: function() {
            $headerRoot.removeClass('b-basket--loading-in-progress');
            ajaxifyBasket();
        },
    });
};

export function init() {
    $(function() {
        ajaxifyBasket();        
    })
}